import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/Footer.css';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <nav className="bottom-tab-bar">
      <NavLink to="/categories" className="tab-item">
        <i className="tab-icon">📋</i>
        <span>{t('all_categories')}</span>
      </NavLink>
      <NavLink to="/favorites" className="tab-item">
        <i className="tab-icon">❤️</i>
        <span>{t('favorites')}</span>
      </NavLink>
      <NavLink to="/history" className="tab-item">
        <i className="tab-icon">🕒</i>
        <span>{t('history')}</span>
      </NavLink>
      <NavLink to="/mypage" className="tab-item">
        <i className="tab-icon">👤</i>
        <span>{t('my_page')}</span>
      </NavLink>
    </nav>
  );
};

export default Footer;
